import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "33",
  height: "42",
  viewBox: "0 0 33 42",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M32.4914 19.0893C31.6184 14.0019 29.507 9.15528 26.9437 4.70607L19.8493 8.84823C21.5603 11.5896 22.9857 14.4213 23.9531 17.4557C25.4484 22.2942 25.623 27.6144 23.8792 32.3225C23.7559 32.6837 23.6163 33.039 23.4663 33.3902C20.0732 25.2543 15.0616 13.0586 11.9088 5.4165C11.7712 5.09139 11.1694 3.6043 11.0379 3.31531C10.1855 1.19606 7.7064 -0.242857 5.40598 0.0340904C2.71121 0.210694 0.377926 2.58481 0.349171 5.23789C0.281391 16.7513 0.23415 29.0654 0 40.5547H8.26508C8.1213 33.7935 8.06379 26.312 7.98985 19.5127C7.98369 18.4912 7.97752 17.1627 7.97136 15.7137C11.0235 23.1552 14.4002 31.3913 16.8711 37.4802C17.3024 38.594 17.9823 39.6114 18.9271 40.3901C22.0696 43.0833 27.262 42.2926 29.394 38.8007C32.7748 32.8764 33.7052 25.7079 32.4914 19.0893Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }